<template>
  <div>
    <div class="card-box" v-if="cardBag.name">
      <div class="vcard-body" v-if="vcardData&&vcardData.avatar">
        <Vcard
          :posterData="vcardData"  @showMark="(e)=>callingcardShow=e"
        ></Vcard>
      </div>
      <div class="card-box-top-img" :style="{'margin-top': vcardData&&vcardData.avatar ? '64px' : 0}" >
        <img
          src="https://img.esenyun.com/images/20200530/2b707e89206846bba96de36ecc7a03c0.png"
        />
      </div>
      <div style="background:#fff;margin-bottom:16rpx">
        <div class="card-box-title">
          <span class="line"></span>
          <span class="name">可领卡包</span>
          <span class="line"></span>
        </div>
          <div style="padding:20rpx 32rpx;background:#fff;">
            <div>
              <div class="card-content" v-for="(item, index) in cardBag.children"
              :key="index" style='margin-bottom:12px' @click="getWxcode">
                <div class="content-left" style="width:35%;border-right:1px dashed #FFD095;">
                  <div v-if="item.couponType=='DISCOUNT'&&item.couponAmount"><span style="font-size:30px;">{{item.couponAmount}}折</span></div>
                  <div v-if="item.couponType=='CASH'&&item.couponAmount">¥<span style="font-size:30px;">{{item.couponAmount}}</span></div>
                  <div v-if="item.couponType=='GIFT'"><img :src="item.goodsUrl" style="width:24px;height:24px;"></div>
                  <div style="font-size:11px;color:#9D7C64;">有效期至{{item.expiredTime}}</div>
                </div>
                <div class="contnet-right">
                  <div class="right-title">
                    <div class="title01">{{item.onlineName}}</div>
                    <div class="span01">{{item.onlineDescription}}</div>
                  </div>
                  <div>
                    <van-button
                      type="danger"
                      round
                      plain
                      custom-style="width:210rpx;border: none;background:linear-gradient(90.12deg, #EA4638 2.31%, #DC2111 99.93%);color:#fff;font-size:26rpx;padding:0;height:64rpx;"
                      @click="clickRollDetail(item,'cardDetail')"
                      >待领取</van-button>
                </div>
                </div>
              </div>
            </div>
        </div>
      </div>
      <div style="background:#fff;">
        <div class="card-box-title">
          <span class="line"></span>
          <span class="name">规则说明</span>
          <span class="line"></span>
        </div>
        <div class="rule-box" v-html="transformText(cardBag.ruleDesc)"></div>
      </div>
      <div class="footer flex-center" v-if="!callingcardShow">
        <LinkWeappBtn
          :url="`fissionEquitys/cardDetail.html?id=${packageId}&shareId=${shareId}`"
        >
          <script type="text/wxtag-template">
              <button style="width: 343px;
                  background: linear-gradient(90.12deg, #EA4638 2.31%, #DC2111 99.93%);
                  color: #fff;
                  font-size: 18px;
                  height: 44px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  border-radius: 50px;
                  border: none;"> 去小程序领取
            </button>
          </script>
        </LinkWeappBtn>
      </div>
    </div>
    <van-popup v-model="qrModel" closeable :style="{ width: '100%' }">
      <div class="qr_code">
        <img :src="url" alt="" />
        <div>微信中长按识别小程序码</div>
        <div>领取优惠</div>
      </div>
    </van-popup>
  </div>
</template>
<script>
// import env from '../../config/env'
import LinkWeappBtn from '../../components/LinkWeappBtn'
import Vcard from '../../components/Vcard'
export default {
  data() {
    return {
      // env: env,
      packageId: '',
      loading: false,
      disabled: false,
      qrModel: false,
      showShare: false,
      shareId: '',
      url: '',
      packageInfo: {},
      params: {},
      detail: {},
      cardBag: {},
      vcardUrl:{},
      callingcardShow:false
    }
  },
  // 局部注册的组件
  components: {
    LinkWeappBtn,
    Vcard
  },
  async mounted() {
    console.log('query', this.$route.query)
    console.log('vcardData', this.$route.query.vcardData)
    console.log('isInitWx', this.$root.$data.store.state.isInitWx)
    if (!this.$root.$data.store.state.isInitWx) {
      this.$root.$data.store.initwx(true, this.$route.query.code)
    }
    this.packageId = this.$route.query.id
    this.shareId = this.$route.query.shareId
    if(this.$route.query.vcardDat!='undefined'){
    this.vcardData = this.$route.query && this.$route.query.vcardData ? JSON.parse(this.$route.query.vcardData) : {}
    }
    this.getCouponDetails()
    this.readyShare()
  },
  methods: {
    transformText(text) {
      if(text) {
        text = text.replace(/\n/g, '<br />')
        return text
      }
    },
    readyShare() {
      window.wx.ready(async () => {
        const shareUrl = `${location.origin}${location.pathname}#/fissionEquitys/cardDetail?id=${this.packageId}&shareId=${this.shareId}&vcardData=${encodeURIComponent(
          JSON.stringify(this.vcardData)
        )}`
        //需在用户可能点击分享按钮前就先调用
        window.wx.onMenuShareAppMessage({
          title: this.coupon.onlineName, // 分享标题
          desc: this.coupon.onlineDescription, // 分享描述
          link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: this.coupon.bannerUrl, // 分享图标
          success: () => {
            // 用户点击了分享后执行的回调函数
          },
        })
        window.wx.onMenuShareTimeline({
          title: this.coupon.onlineName, // 分享标题
          link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: this.coupon.bannerUrl, // 分享图标
          success: () => {
            // 用户点击了分享后执行的回调函数
          },
        })
      })
    },
    // 获取卡包详情
    getCouponDetails() {
      this.$http
        .get(`aocampaign/openapi/coupon/package/rights-package-detail/${this.packageId}?shareId=${this.shareId}`)
        .then((res) => {
          if (!res.data) {
            return false
          }
          this.cardBag = res.data
          document.title = this.cardBag.name
        })
    },
    goToDetails() {
      // uni.navigateTo({
      //   url: `/cardBag/couponDetail?id=${id}&from=cardBag&packageId=${this.packageId}`,
      // })
    },
    async getWxcode() {
      this.url = await this.$share.getPosterNew(
        {
          id: this.packageId,
          shareId: this.shareId,
        },
        'fissionEquitys/cardDetail'
      )
      this.qrModel = true
    },
  },
}
</script>
<style lang="less" scoped>
.apply-btn {
   width: 343px;
   background: linear-gradient(270deg, #EA4638 0%, #DC2111 100%);
    color: #fff;
    font-size: 16px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 40px;
    border: none;
}
.card-box {
  position: relative;
  padding-bottom: 120px;
}
.card-box-top-img img {
  width: 100%;
  height: 99px;
}
.card-box-title {
  padding: 12px 0;
  text-align: center;
  .line {
    display: inline-block;
    width: 32px;
    height: 1px;
    background: #c8c9cc;
    vertical-align: middle;
  }
  .name {
    font-size: 13px;
    margin: 0 8px;
    font-weight: 600;
  }
}
.coupon-box {
  padding: 0 20px 12px;
}
.coupon-box-item {
  margin-bottom: 8px;
}
.rule-box {
  padding: 0 20px 20px;
  font-size: 14px;
  word-break: break-all;
  word-wrap: break-word;
  line-height: 22px;
}
.footer {
  padding: 12px 0 20px 0;
  justify-content: center;
  .btn {
    padding: 0 6px;
  }
}
.items {
  width: 60px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 11px;
  line-height: 20px;
}
.card-content {
    background: #fcf6ea;
    padding: 16px 8px 16px 16px;
    font-size: 13px;
    color: #fd533e;
    border-radius: 5px;
    display: flex;
    .contnet-right {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-left: 14px;
      box-sizing: border-box;
      flex: 1;
      .right-title {
        box-sizing: border-box;
        width: 115px;
        .title01 {
          font-weight: 600;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-bottom: 5px;
        }
        .span01 {
          font-size: 11px;
          color: #9d7c64;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .right-but {
        color: #fd533e;
        border: 1px solid #fd533e;
        box-sizing: border-box;
        border-radius: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 71px;
        height: 32px;
      }
    }
  }
  .vcard-body {
    width: 100%;
    position: fixed;
    z-index: 99;
    top: 0;
    background: #fff;
    height: 64px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    padding: 0 16px;
  }
</style>
